// extracted by mini-css-extract-plugin
export var divider = "_yf-0";